export default __webpack_public_path__ + "static/media/volume-full-icon.c77d9a13.svg";